import React from 'react'

const ComplaintsProcedurePage = () => {
  return (

  <>
	  <div dangerouslySetInnerHTML={{ __html: 
    `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<title>File a Complaint - LusidPay</title>
<style>
  body {
    background-color: #f9fafb;
    color: #333;
    margin: 0; 
  }
  .container {
    max-width: 700px;
    margin: auto;
    background: white;
    padding: 30px;
    box-shadow: 0 2px 10px rgb(0 0 0 / 0.1);
  }
  h1, h3 {
    color: #004080; /* Customize to LusidPay brand color */
    margin-top: 25px;
    margin-bottom: 10px;
  }
  p {
    line-height: 1.6;
  }
  ul {
    list-style-type: disc;
    margin-left: 20px;
  }
  label {
    font-weight: bold;
    display: block;
    margin-top: 15px;
  }
  input[type="text"], input[type="email"], textarea {
    width: 100%;
    padding: 8px;
    margin-top: 6px;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-size: 1em;
  }
  textarea {
    resize: vertical;
    min-height: 100px;
  }
  button {
    background-color: #004080; /* LusidPay brand color */
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 4px;
    font-size: 1em;
    cursor: pointer;
    margin-top: 20px;
  }
  button:hover {
    background-color: #002f5c;
  }
  .note {
    font-size: 0.9em;
    color: #666;
    margin-top: 15px;
  }
</style>
</head>

<body>
  <div class="container">
    <h1>Filing a Complaint</h1>
    <p>At LusidPay, we take every complaint seriously. We're committed to resolving concerns promptly, fairly, and transparently. If something hasn’t met your expectations, we want to hear about it, and make it right.</p>

    <h3>What is a Complaint?</h3>
    <p>A complaint is any expression of dissatisfaction about a financial service, whether made orally or in writing, that alleges financial loss, distress, or inconvenience.</p>

    <h3>How to File a Complaint</h3>
    <p>To submit a formal complaint, please email us at</p>
    <p><strong>complaints@lusid.ai</strong></p>
    <p>Your message should include:</p>
    <ul>
      <li>Who you are</li>
      <li>What happened</li>
      <li>When it happened</li>
      <li>What outcome you’re seeking</li>
    </ul>
    <p>Providing as much detail as possible helps us investigate and resolve your complaint effectively.</p>

    <h3>Types of Complaints</h3>
    <p>Please indicate which of the following categories best applies to your complaint:</p>
    <ul>
      <li><strong>Customer Service:</strong> Issues with interactions or support experience</li>
      <li><strong>Account Opening:</strong> Problems during onboarding or setup</li>
      <li><strong>Account Closing:</strong> Challenges closing your account</li>
      <li><strong>Fraud:</strong> Reports of unauthorized activity</li>
      <li><strong>Fees:</strong> Issues related to fees charged or fee structure</li>
      <li><strong>Servicing:</strong> General account maintenance concerns</li>
      <li><strong>Other:</strong> Any other concerns not listed above</li>
    </ul>

    <h3>What Happens After You Submit a Complaint</h3>
    <ul>
      <li><strong>Acknowledgment (within 1 business day):</strong> We will acknowledge receipt of your complaint within one business day.</li>
      <li><strong>Final Response (within 15 business days):</strong> We aim to issue a final decision within 15 business days. If we are unable, you will receive a holding response by day 15 and a final resolution no later than 35 business days from receipt.</li>
    </ul>

    <h3>Resolution Summary</h3>
    <p>Our final response will include:</p>
    <ul>
      <li>A summary of your complaint</li>
      <li>The results of our investigation</li>
      <li>Our decision and the rationale behind it</li>
    </ul>

    <h3>Complaints related to International payments/collections</h3>
    <p>We work with e-money and payments institution partners in providing you with our service, namely Currencycloud. Currencycloud ultimately provides you with regulated payments and e-money services in US. Currencycloud has certain obligations as a regulated financial services institutions, including around complaints. We keep them informed of the complaints we receive from you regarding the regulated payments and e-money services they ultimately provide to you. They oversee how we handle complaints to ensure we do this to the standard required under the regulations. However, if for any reason your complaint regarding your payments and e-money services has not been acknowledged or dealt with by us, or if you have concerns about the way it has been handled, Currencycloud's complaints information can be found <a href="https://www.currencycloud.com/legal/complaints-procedure/" target="_blank" rel="noopener">here</a>.</p>
    <p>If you're not satisfied with the resolution provided, you have the right to escalate your complaint to a regulatory authority. U.S. customers may contact the Consumer Financial Protection Bureau (CFPB): <a href="https://www.consumerfinance.gov/complaint/" target="_blank" rel="noopener">https://www.consumerfinance.gov/complaint/</a></p>

    <h3>We're Here to Help</h3>
    <p>Your feedback helps us improve. Thank you for taking the time to share your experience—we’re committed to resolving your concern thoroughly and respectfully.</p>

  </div>
</body>
</html>` }} />
</>
  )
}

export default ComplaintsProcedurePage;